import React, { useState, useEffect } from 'react';
import { Accordion, Card, OverlayTrigger, Spinner } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Loader from '../../../Components/Utility/Loader/Loader';
import BtnAdd from '../../../Components/Utility/FilterAction/BtnAdd';
import CardDrag from './CardDrag';
import * as action from '../Store/SystemMasters.action';
import * as devAction from '../../DevlopmentOrder/store/DevelopmentOrder.action';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function MeasurementMaster({
  addMeasurement,
  mmBtnDisable,
  isMMUnique,
  renderTooltipOpenClosePsm,
  callApi,
  buttonDownMm,
  btnCall,
  showMM,
  isLoadingMM,
  measurementData,
  handleCheckboxST,
  handleChanged,
  renderTooltipActiveInactive,
  activeInactiveClicked,
  renderTooltipDelete,
  handleDelete,
  saveMeasurement,
  isSSM,
  handleMeasurement,
  isUniqueId,
  OpenReArrangeFunction,
}) {
  const [scrollEl, setScrollEl] = useState();
  const [cards, setCards] = useState([]);
  const [eCommAccess, setECommAccess] = useState();
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const { t } = useTranslation('common');
  const {
    Users: { logInRights },
  } = reducer;
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);

  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'exchangeRates', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'exchangeRates', 'delete');
  useEffect(() => {
    if (Array.isArray(measurementData)) {
      const item = [...measurementData];
      setCards(item);
    }
  }, [measurementData]);

  const renderCard = (card, index) => {
    return (
      <CardDrag
        key={card?.id}
        index={index}
        id={card?.id}
        item={card}
        handleCheckboxST={handleCheckboxST}
        handleChanged={handleChanged}
        renderTooltipActiveInactive={renderTooltipActiveInactive}
        activeInactiveClicked={activeInactiveClicked}
        renderTooltipDelete={renderTooltipDelete}
        handleDelete={handleDelete}
        handleMeasurement={handleMeasurement}
        isMMUnique={isMMUnique}
        isUniqueId={isUniqueId}
        masterAddEditAccess={MasterAddEditAccess}
        masterDeleteAccess={MasterDeleteAccess}
      />
    );
  };

  useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 1000;
    }
  }, [scrollEl]);

  const handleSwitch = (e) => {
    setECommAccess(!eCommAccess);
    dispatch(action.setMasterAccess({ key: 'eCommSpec', val: e.target.checked }));
  };

  useEffect(() => {
    const Init = async () => {
      const ecommAccessRes = await dispatch(devAction.getEcommSpec('eCommSpec'));
      setECommAccess(ecommAccessRes?.isActive);
    };
    Init();
  }, []);

  return (
    <Accordion className="mb-4 master-accordian">
      <Card>
        <Card.Header>
          <div className="title-container d-flex">
            {MasterAddEditAccess ? (
              <div className="custom-control custom-switch">
                <input type="checkbox" className="custom-control-input" id="customSwitch1" checked={eCommAccess} onChange={(e) => handleSwitch(e)} />
                <label className="custom-control-label" htmlFor="customSwitch1" />
              </div>
            ) : (
              ''
            )}
            <p>{t('MEASUREMENT_MASTER.ECOMM_SPEC_TITLE')}</p>
          </div>
          <div className={!MasterAddEditAccess ? 'action-title-btns single-btn' : 'action-title-btns'}>
            {MasterAddEditAccess && (
              <button
                type="button"
                onClick={() => OpenReArrangeFunction('eCommSpecMaster')}
                className="filter-btn filter-button_add"
                disabled={mmBtnDisable || !isMMUnique}
                aria-label="Rearrange"
                title={t('MEASUREMENT_MASTER.REARRANGE')}
              >
                <span className="icon-expand" />
              </button>
            )}
            <BtnAdd onBtnClick={addMeasurement} forDisable={mmBtnDisable || !isMMUnique} addEditAccess={MasterAddEditAccess} />
            <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipOpenClosePsm}>
              <button type="button" onClick={() => callApi('measurementMaster')}>
                {btnCall(buttonDownMm)}
              </button>
            </OverlayTrigger>
          </div>
        </Card.Header>
        {showMM &&
          (isLoadingMM ? (
            <Loader />
          ) : (
            <Card.Body>
              <PerfectScrollbar
                containerRef={(ref) => {
                  setScrollEl(ref);
                }}
              >
                <ul>{cards?.map((sTEle, sTIndex) => renderCard(sTEle, sTIndex))}</ul>
              </PerfectScrollbar>
              {MasterAddEditAccess && (
                <div className="section-save">
                  <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                    <button
                      aria-label="Save"
                      className="btn btn-page-filter btn-white ml-auto"
                      type="button"
                      onClick={saveMeasurement}
                      disabled={mmBtnDisable || !isMMUnique}
                    >
                      {isSSM ? (
                        <Spinner animation="border" />
                      ) : (
                        <>
                          <span className="icon-Save c-button-align f-20 mr-2" /> {t('PRODUCT_IDENTIFIER.SAVE')}
                        </>
                      )}
                    </button>
                  </CustomTooltip>
                </div>
              )}
            </Card.Body>
          ))}
      </Card>
    </Accordion>
  );
}

export default MeasurementMaster;
